import { render, staticRenderFns } from "./StudentLeaveSubSubSitute.vue?vue&type=template&id=24a895e6&scoped=true&"
import script from "./StudentLeaveSubSubSitute.vue?vue&type=script&lang=js&"
export * from "./StudentLeaveSubSubSitute.vue?vue&type=script&lang=js&"
import style0 from "./StudentLeaveSubSubSitute.vue?vue&type=style&index=0&id=24a895e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a895e6",
  null
  
)

export default component.exports